import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useActionRequest } from "../../../common/hooks/api";
import { NetworkRequest } from "../../../common/models";
import { Api } from "../../../common/service/Api";
import { PageHeader } from "../../components/layout/header/Header";
import {
  LoadingPageWrapper,
  StandardPageWrapper,
} from "../../components/layout/StandardPageWrapper";
import { Error as OrganizationError } from "../../copy/organization";
import { useOrganization, usePrimaryOrganization } from "../../hooks";
import { OrganizationSettingsView } from "./OrganizationSettingsView";
import { SettingsTabs } from "./SettingsTabs";
import { usePrivacyCenterSettings } from "../../components/superorg/settings/PrivacyCenterSettings";

export const OrganizationSettings = () => {
  const [org] = usePrimaryOrganization();
  const organizationId = org.id;

  const [organization, orgRequest, orgRefresh] = useOrganization(organizationId);

  const { privacyCenter } = usePrivacyCenterSettings();

  const [everRendered, setEverRendered] = useState(false);

  const updateOrganizationApi = useCallback(
    (submitValues) => Api.organization.updateOrganization(organizationId, submitValues),
    [organizationId],
  );

  const updateOrganizationMessages = useMemo(
    () => ({
      forceError: OrganizationError.UpdateOrganization,
    }),
    [],
  );

  const { fetch: updateOrganization } = useActionRequest({
    api: updateOrganizationApi,
    messages: updateOrganizationMessages,
    onSuccess: orgRefresh,
  });

  useEffect(() => {
    if (NetworkRequest.areFinished(orgRequest)) {
      setEverRendered(true);
    }
  }, [orgRequest]);

  const handleFormSubmit = (values) => {
    updateOrganization(Object.assign({}, organization, values));
  };

  // Page Load
  if (!everRendered) {
    return <LoadingPageWrapper />;
  }

  // Page Content
  return (
    <StandardPageWrapper>
      <div className="max-width-896">
        <PageHeader titleContent="Settings" />
        <SettingsTabs current="settings" />
        <OrganizationSettingsView
          organization={organization}
          updateOrganization={handleFormSubmit}
          privacyCenter={privacyCenter}
        />
      </div>
    </StandardPageWrapper>
  );
};
